import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
/** Surrender confirmation. Victory is awarded to the opponent. */
export default class SurrenderConfirmModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", false);
  }
  className() {
    return 'ArenaSurrenderModal Modal--small';
  }
  title() {
    return m('[', null, m("i", {
      className: "fas fa-flag"
    }), " ", app.translator.trans('forumaker-arena.forum.surrender.title'));
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("p", {
      className: "ArenaSurrenderModal-text"
    }, app.translator.trans('forumaker-arena.forum.surrender.confirm_text')), m("div", {
      className: "ArenaSurrenderModal-actions"
    }, m(Button, {
      className: "Button Button--danger Button--block",
      icon: "fas fa-flag",
      loading: this.loading,
      onclick: () => this.surrender()
    }, app.translator.trans('forumaker-arena.forum.surrender.confirm_btn')), m(Button, {
      className: "Button Button--block",
      disabled: this.loading,
      onclick: () => this.hide()
    }, app.translator.trans('forumaker-arena.forum.surrender.cancel_btn'))));
  }
  async surrender() {
    this.loading = true;
    m.redraw();
    try {
      var _this$attrs$onSurrend, _this$attrs;
      await app.request({
        method: 'POST',
        url: "".concat(app.forum.attribute('apiUrl'), "/arena/battles/").concat(this.attrs.battle.id(), "/surrender")
      });
      this.hide();
      (_this$attrs$onSurrend = (_this$attrs = this.attrs).onSurrendered) == null || _this$attrs$onSurrend.call(_this$attrs);
    } catch (_unused) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('forumaker-arena.forum.surrender.error'));
      this.loading = false;
      m.redraw();
    }
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/SurrenderConfirmModal', SurrenderConfirmModal);